import {createFeatureSelector, createSelector} from '@ngrx/store';
import {StoreKeys} from '../../models/store-keys';
import {SearchResultPaginationState} from './reducer/search-result-pagination.reducer';


export const selectSearchResultPaginationFeature = createFeatureSelector<SearchResultPaginationState>(StoreKeys.SEARCH_RESULT_PAGINATION);

export const selectSearchResultPaginationDatas = createSelector(selectSearchResultPaginationFeature, state => state.datas);
